module.exports = __webpack_public_path__ + "img/calendar-information.631b4ecb.svg";